import React from 'react'
import { Link, Redirect } from 'react-router-dom'
import axios from 'axios';
import DocumentMeta from 'react-document-meta';
import imageCompression from 'browser-image-compression';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faCamera } from '@fortawesome/free-solid-svg-icons'

import AppContext from '../../../AppContext.js';
import OffsetTop from '../../../components/offsetTop.js';
import Preview from '../../../components/preview.js';

const localization = {
    ua: {
        title: 'Рейс',
        filter: {
            date: 'Дата'
        },
        noData: 'Данi вiдсутнi',
    },
    ru: {
        title: 'Рейс',
        filter: {
            date: 'Дата'
        },
        noData: 'Данi вiдсутнi',
    },
    en: {
        title: 'Рейс',
        filter: {
            date: 'Дата'
        },
        noData: 'Данi вiдсутнi',
    },
}

class InspectionWorkshopList extends React.Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
		
		this.state = {
            isLoading: true,
            redirect: null,
            stateChangeConfirm: true,

            did: null,
            balance: '',

            costs: [],

            tab: 'expenses',

            isTripCheckpoint: false,
            arriveItem: null,
            arrivedRemark: '',

            uploadFolder: "",
            uploadContext: "",
            uploadSubfolder: "",
        }

        this.load = this.load.bind(this);
        this.expenseStateChange = this.expenseStateChange.bind(this);
        this.delete = this.delete.bind(this);

        this.changeArrivedRemark = this.changeArrivedRemark.bind(this);
        this.arrive = this.arrive.bind(this);
    }

    componentDidMount() {
        const {lang, setMenuExpandText} = this.context;
        setMenuExpandText(localization[lang].title);

        this.setState({did: Number(this.props.match.params.did)}, () => {
            this.load();
        });
    }

    load() {
        const {addNotification, removeNotification, token, setMenuExpandText, lang} = this.context;
        
        if (process.env.NODE_ENV === 'production') {
            var u = addNotification("Завантаження...");

            var cardPromise = axios.post('/api/driver/expenses/card', { token: token, did: this.state.did });
            var costsPromise = axios.post('/api/driver/expenses/costs', { token: token, did: this.state.did });
            var tripsPromise = axios.post('/api/driver/expenses/trips', { token: token, did: this.state.did });

            axios.all([cardPromise, costsPromise, tripsPromise]).then(axios.spread((card, costs, trips) => {
                this.setState({
                    did: card.data.rows[0].did, 
                    date: card.data.rows[0].date, 
                    number: card.data.rows[0].number, 
                    status: card.data.rows[0].status, 
                    state: card.data.rows[0].state, 
                    driver1Id: card.data.rows[0].driver1Id,
                    driver1Name: card.data.rows[0].driver1Name,
                    driver1Phone: card.data.rows[0].driver1Phone,
                    driver1Details: card.data.rows[0].driver1Details,
                    driver2Id: card.data.rows[0].driver2Id,
                    driver2Name: card.data.rows[0].driver2Name,
                    driver2Phone: card.data.rows[0].driver2Phone,
                    driver2Details: card.data.rows[0].driver2Details,
                    vehicle: card.data.rows[0].vehicle, 
                    name: card.data.rows[0].name, 
                    time: card.data.rows[0].time, 
                    remark: card.data.rows[0].remark, 
                    expenses: card.data.rows[0].expenses, 
                    rid: card.data.rows[0].rid, 
                    rname: card.data.rows[0].rname, 
                    files: card.data.rows[0].files,

                    costs: costs.data.rows,
                    trips: trips.data.rows,
                }, () => {
                    setMenuExpandText(localization[lang].title + ": " + this.state.number);
                    this.balance();
                });
            })).catch((error) => {
                addNotification(error.response.data, error.response.status);
            }).finally(function () {
                removeNotification(u);
            });
        } else {
            this.setState({
                did: "13", 
                date: "20.10.2019", 
                number: "12345678",
                status: "Done",
                state: 33,
                driver1Id: 1,
                driver1Name: "Yevhenii",
                driver1Phone: "123456",
                driver1Details: "main driver",
                driver1Id: 2,
                driver2Name: "Oleh",
                driver2Phone: "654321",
                driver2Details: "second driver",
                vehicle: "Kia Sportage",
                name: "Fuel check", 
                time: "30.08.2023 13:00:00 .. 02.09.2023 16:05:00", 
                remark: "Remark text example",
                expenses: "1549 UAH",
                rid: 3, 
                rname: "R3 (9.4)", 
                files: ["qwer/qwer.pdf", "qwer/qwer.pdf"],

                costs: [
                    {
                        did: 13, 
                        item: 1,
                        type: "Fuel",
                        tid: 3,
                        payment: "Cash",
                        date: "30.08.2023 13:00:00",
                        country: "Ukraine",
                        currency: "UAH",
                        sumExch: "225",
                        currencyExch: "UAH",
                        liters: "15L",
                        expedition: "UA->PL",
                        sum: "1499.50",
                        remark: "Remark text example",
                        files: ["qwer/qwer.pdf", "qwer/qwer.pdf"],
                    },
                ],
                trips: [
                    {
                        did: 13, 
                        item: 1,
                        type: "Початок маршруту",
                        point: "Дубно",
                        vacation: "",
                        waiting: "",
                        plantime: "01.11.2023 9:00:00",
                        facttime: "4:25:00",
                        factdiff: "1:14",
                        remark: "",
                        bid: 1,
                        bname: "B1",
                        fileRequired: 1,
                        fileRequiredMessage: "File Required Message",
                        files: ["qwer/qwer.pdf", "qwer/qwer.pdf"],
                    },
                    {
                        did: 13, 
                        item: 2,
                        type: "Приїзд на кордон",
                        point: "Устилуг",
                        vacation: "",
                        waiting: "",
                        plantime: "01.11.2023 11:20:00",
                        facttime: "",
                        factdiff: "",
                        remark: "",
                        bid: 1,
                        bname: "B1",
                        fileRequired: 0,
                        fileRequiredMessage: "",
                        files: ["qwer/qwer.pdf", "qwer/qwer.pdf"],
                    },
                    {
                        did: 13, 
                        item: 3,
                        type: "Перетин КПП виїзд з України",
                        point: "Устилуг",
                        vacation: "09:00",
                        waiting: "04:00",
                        plantime: "02.11.2023 2:20:00",
                        facttime: "",
                        factdiff: "",
                        remark: "",
                        bid: 1,
                        bname: "B1",
                        fileRequired: 1,
                        fileRequiredMessage: "File Required Message",
                        files: ["qwer/qwer.pdf", "qwer/qwer.pdf"],
                    },
                    {
                        did: 13, 
                        item: 4,
                        type: "Виїзд",
                        point: "Зосин",
                        vacation: "",
                        waiting: "",
                        plantime: "02.11.2023 2:20:00",
                        facttime: "",
                        factdiff: "",
                        remark: "",
                        bid: 1,
                        bname: "B1",
                        fileRequired: 1,
                        fileRequiredMessage: "File Required Message",
                        files: ["qwer/qwer.pdf", "qwer/qwer.pdf"],
                    },
                    {
                        did: 13, 
                        item: 5,
                        type: "Приїзд на завод",
                        point: "Уязд(Euroglas)",
                        vacation: "1 д.",
                        waiting: "",
                        plantime: "03.11.2023 8:05:00",
                        facttime: "",
                        factdiff: "",
                        remark: "",
                        bid: 1,
                        bname: "B1",
                        fileRequired: 1,
                        fileRequiredMessage: "File Required Message",
                        files: ["qwer/qwer.pdf", "qwer/qwer.pdf"],
                    },
                    {
                        did: 13, 
                        item: 6,
                        type: "Завантаження",
                        point: "Уязд(Euroglas)",
                        vacation: "",
                        waiting: "",
                        plantime: "03.11.2023 13:05:00",
                        facttime: "",
                        factdiff: "",
                        remark: "",
                        bid: 1,
                        bname: "B1",
                        fileRequired: 1,
                        fileRequiredMessage: "File Required Message",
                        files: ["qwer/qwer.pdf", "qwer/qwer.pdf"],
                    },
                    {
                        did: 13, 
                        item: 7,
                        type: "Виїзд з заводу",
                        point: "Уязд(Euroglas)",
                        vacation: "",
                        waiting: "",
                        plantime: "03.11.2023 13:05:00",
                        facttime: "",
                        factdiff: "",
                        remark: "",
                        bid: 1,
                        bname: "B1",
                        fileRequired: 1,
                        fileRequiredMessage: "File Required Message",
                        files: ["qwer/qwer.pdf", "qwer/qwer.pdf"],
                    }
                ],
            }, () => {
                setMenuExpandText(localization[lang].title + ": " + this.state.number);
                this.balance();
            });
        }
    }

    balance() {
        const {addNotification, removeNotification, token} = this.context;

        if (process.env.NODE_ENV === 'production') {
            var u = addNotification("Завантаження...");
            axios.post('/api/driver/expenses/balance', { 
                token: token, 
                id: this.state.driver1Id,
            }).then((res) => {
                this.setState({
                    isLoading: false,
                    balance: res.data.rows[0].balance,
                });
            }).catch((error) => {
                addNotification(error.response.data, error.response.status);
            }).finally(function () {
                removeNotification(u);
            });
        } else {
            this.setState({
                isLoading: false,
                balance: '468.40 UAH, 170.00 EUR, -777.85 AZN, -3043.00 MDL, -13.00 PLN, 31.00 CZK',
            });
        }
    }

    expenseStateChange(state) {
        const {addNotification, removeNotification, token} = this.context;

        if (this.state.stateChangeConfirm && state == "33") {
            this.setState({stateChangeConfirm: false});
            return
        }

        if (this.state.stateChangeConfirm && state == "13") {
            this.setState({stateChangeConfirm: false});
            return
        }

        var u = addNotification("Завантаження...");
        axios.post('/api/driver/expenses/state', { 
            token: token, 
            did: Number(this.state.did),
            state: Number(state),
        }).then((res) => {
            if (res.data.serror == "") {
                this.setState({stateChangeConfirm: true}, () => this.load());
            } else {
                addNotification(res.data.serror, 2);
            }
        }).catch((error) => {
            addNotification(error.response.data, error.response.status);
        }).finally(function () {
            removeNotification(u);
        });
    }

    delete(item) {
        const {addNotification, removeNotification, token} = this.context;

        var u = addNotification("Завантаження...");
        axios.post('/api/driver/expenses/delete', { 
            token: token, 
            did: Number(this.state.did),
            item: Number(item),
        }).then((res) => {
            if (res.data.serror == "") {
                this.load();
            } else {
                addNotification(res.data.serror, 2);
            }
        }).catch((error) => {
            addNotification(error.response.data, error.response.status);
        }).finally(function () {
            removeNotification(u);
        });
    }

    removeFile = (filename, folder, context, subfolder) => {
        const {addNotification, removeNotification} = this.context;

        var u = addNotification("Завантаження...");
        axios.post('/api/driver/expenses/attachment/remove', { filename: filename, folder: folder + "", context: context, subfolder: subfolder + ""  }).then((res) => {
            //remove file names to list
            this.removeFromFileList(folder, context, subfolder, filename);
        }).catch((error) => {
            addNotification(error.response.data, error.response.status);
        }).finally(function () {
            removeNotification(u);
        });
    }

    triggerFileInput = (folder, context, subfolder) => {
        this.setState({
            uploadFolder: folder + "", 
            uploadContext: context + "", 
            uploadSubfolder: subfolder + "", 
        }, () => {
            document.getElementById("fileInput").click();
        });
    }

    changeFileInput = event => {
        const {addNotification, removeNotification} = this.context;

        // Copy files to array
        var files = [];
        for (var i = 0; i < event.target.files.length; i++) {
            files.push(event.target.files[i]);
        }
        event.target.value = null;

        // Create data object
        var data = new FormData();
        data.append('length', files.length);
        data.append('folder', this.state.uploadFolder)
        data.append('context', this.state.uploadContext)
        data.append('subfolder', this.state.uploadSubfolder)

        // Attach files to data object
        var compressPromises = [];
        var fileIndex = 0; // file index because compressed images has different order

        for (var i = 0; i < files.length; i++) {
            if (files[i].type == "video/mp4" || files[i].type == "application/pdf") {
                var p = files[i].name.split(".");
                data.append("file"+fileIndex, files[i], p[0].replace(/[^a-z0-9]/gi, '_').toLowerCase()+"."+p[1]);
                fileIndex = fileIndex++;
            } else {
                compressPromises.push(imageCompression(files[i], {
                    maxSizeMB: 10,
                    maxWidthOrHeight: 1920,
                    useWebWorker: true
                }));
            }
        }

        // Images should be compressed, wait
        Promise.all(compressPromises).then(results => {
            results.forEach(compressedFile => {
                var p = compressedFile.name.split(".");
                data.append("file"+fileIndex, compressedFile, p[0].replace(/[^a-z0-9]/gi, '_').toLowerCase()+"."+p[1]);
                fileIndex = fileIndex++;
            });

            var u = addNotification("Завантаження...");
            axios.post('/api/driver/expenses/attachment/add', data).then((res) => {
                if (this.state.uploadContext === "costs") {
                    var i = this.state.costs.findIndex((c) => {
                        return c.item + "" == this.state.uploadSubfolder
                    });
                    this.state.costs[i].files.push(res.data.filename);
                    this.forceUpdate();
                } else if (this.state.uploadContext === "trips") {
                    var i = this.state.trips.findIndex((c) => {
                        return c.item + "" == this.state.uploadSubfolder
                    });
                    this.state.trips[i].files.push(res.data.filename);
                    this.forceUpdate();
                } else {
                    this.state.files.push(res.data.filename);
                    this.forceUpdate();
                }
                
                this.setState({
                    uploadFolder: "",
                    uploadContext: "",
                    uploadSubfolder: "",
                });
            }).catch((error) => {
                addNotification(error.response.data, error.response.status);
            }).finally(function () {
                removeNotification(u);
            });
        });
    }

    removeFromFileList(folder, context, subfolder, filename) {
        if (context === "costs") {
            var i = this.state.costs.findIndex((c) => {
                return c.item + "" == subfolder + ""
            });
            var fi = this.state.costs[i].files.findIndex((fitem) => {
                return fitem == filename
            });
            this.state.costs[i].files.splice(fi, 1);
            this.forceUpdate();
        } else if (context === "trips") {
            var i = this.state.trips.findIndex((c) => {
                return c.item + "" == subfolder + ""
            });
            var fi = this.state.trips[i].files.findIndex((fitem) => {
                return fitem == filename
            });
            this.state.trips[i].files.splice(fi, 1);
            this.forceUpdate();
        } else {
            var fi = this.state.files.findIndex((fitem) => {
                return fitem == filename
            });
            this.state.files.splice(fi, 1);
            this.forceUpdate();
        }
    }

    renderExpensesList() {
        const {lang} = this.context;

        if (this.state.costs.length === 0) {
            return (
                <div className="row">
                    <div className="col">
                        <div className="card agis-card">
                            <div className="row">
                                <div className="col" style={{display: "flex", alignItems: "center", height: "30px"}}>
                                    <div>
                                        <h6><b>{localization[lang].noData}</b></h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return this.state.costs.map((item, i) => {
                return (
                    <div className="row mb-2" key={"list_" + i}>
                        <div className="col">
                            <div className="card-agis pt-2 pb-2" style={{borderRadius: "15px"}}>
                                <div>
                                    <big>{item.date}, {item.country}, {item.type} {item.expedition != "" ? "("+item.expedition+")" : ""}</big>
                                </div>
                                <div>
                                    <big className='text-info'>{item.payment}</big>
                                </div>
                                <div>
                                    <big><i>{item.remark}</i></big>
                                </div>
                                <div className="text-right">
                                    <big className="text-success"><b>{item.sum} {item.currency}{item.liters != "0.00" ? ", "+item.liters+" літрів" : ""}{item.sumExch != "0.00" ? " -> "+item.sumExch+" "+item.currencyExch : ""}</b></big>
                                </div>
                                {this.state.state != 13 && this.state.state != 23 ? (
                                    (this.state.state == 33 && item.tid != 7 && item.tid != 9) && (
                                        <div class="d-flex justify-content-between mt-2">
                                            <button className="btn-agis-light-outline" style={{height: "30px", width: "50px", minWidth: "30px"}} onClick={() => {this.triggerFileInput(this.state.did, "costs", item.item+"")}}><FontAwesomeIcon icon={faCamera}/></button>
                                            <button className="btn-agis-light-outline" style={{height: "30px", width: '49%', minWidth: "0px", border: "1px solid #ebebeb"}} onClick={() => this.setState({redirect: "/driver/expenses/"+this.state.did+"/"+item.item+"/"+item.tid})}>Редагувати</button>
                                            <button className="btn-agis-danger-outline" style={{height: "30px", width: '49%', minWidth: "0px"}} onClick={() => this.delete(item.item)}>Видалити</button>
                                        </div>
                                    )
                                ) : (
                                    (this.state.state == 33 && item.tid != 7 && item.tid != 9) && (
                                        <div class="d-flex justify-content-between mt-2">
                                            <button className="btn-agis-light-outline" style={{height: "30px", width: '49%', minWidth: "0px", border: "1px solid #ebebeb"}} onClick={() => this.setState({redirect: "/driver/expenses/"+this.state.did+"/"+item.item+"/"+item.tid})}>Редагувати</button>
                                            <button className="btn-agis-danger-outline" style={{height: "30px", width: '49%', minWidth: "0px"}} onClick={() => this.delete(item.item)}>Видалити</button>
                                        </div>
                                    )
                                )}
                                {item.files.length > 0 && (
                                    <div className="row mt-2">
                                        {item.files.map((file) =>
                                            <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                                                <Preview src={"/serve/driver/expenses/"+this.state.did+"/costs/"+item.item+"/"+file} removeFile={this.state.state != 13 && this.state.state != 23 ? () => {this.removeFile(file, this.state.did, "costs", item.item)} : null} />
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            });
        }
    }

    changeArrivedRemark(event) {
        this.setState({arrivedRemark: event.target.value});
    }

    arrive() {
        const {addNotification, removeNotification, token} = this.context;

        var u = addNotification("Завантаження...");
        axios.post('/api/driver/expenses/arrive', { 
            token: token, 
            did: Number(this.state.did),
            item: Number(this.state.arriveItem.item),
            remark: this.state.arrivedRemark,
        }).then((res) => {
            if (res.data.serror == "") {
                this.setState({isTripCheckpoint: false, arrivedRemark: '', arriveItem: null}, () => this.load())
            } else {
                addNotification(res.data.serror, 2);
            }
        }).catch((error) => {
            addNotification(error.response.data, error.response.status);
        }).finally(function () {
            removeNotification(u);
        });
    }

    renderTripList() {
        const {lang} = this.context;

        if (this.state.trips.length === 0) {
            return (
                <div className="row">
                    <div className="col">
                        <div className="card agis-card">
                            <div className="row">
                                <div className="col" style={{display: "flex", alignItems: "center", height: "30px"}}>
                                    <div>
                                        <h6><b>{localization[lang].noData}</b></h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return this.state.trips.map((item, i) => {
                return (
                    <div className="row mb-2" key={"list_t_" + i}>
                        <div className="col">
                            <div className="card-agis pt-2 pb-2" style={{borderRadius: "15px"}}>
                                <div>
                                    <big>
                                        {item.plantime}, {item.type}
                                        {item.bid != 0 && (<span className={item.bid == 1 ? "badge-danger ml-2" : item.bid == 2 ? "badge-warning ml-2" : item.bid == 3 ? "badge-success ml-2" : ""} style={{padding: "3px 5px", borderRadius: "4px"}}><b>{item.bname}</b></span>)}
                                    </big>
                                </div>
                                <div>
                                    <big className='text-info'>{item.point}</big>
                                </div>
                                {item.waiting != '' && (
                                    <div>
                                        <big className='text-success'>Час очікування: {item.waiting}</big>
                                    </div>
                                )}
                                <div className='mb-2'>
                                    <big><i>{item.remark}</i></big>
                                </div>

                                {item.facttime == '' ? (
                                    <div class="d-flex justify-content-between mt-2">
                                        {this.state.state != 13 && this.state.state != 23 && (
                                            <button className="btn-agis-light-outline" style={{height: "30px", width: "50px", minWidth: "30px"}} onClick={() => {this.triggerFileInput(this.state.did, "trips", item.item+"")}}><FontAwesomeIcon icon={faCamera}/></button>
                                        )}
                                        <button className="btn-agis-primary-outline" style={{height: "30px", width: '100%', minWidth: "0px", border: "1px solid #ebebeb"}} onClick={() => this.setState({isTripCheckpoint: true, arriveItem: item})}>Виконано</button>
                                    </div>
                                ) : (
                                    <div>
                                        <big><b>Час виконання: {item.facttime}</b></big>
                                        {item.factdiff != '' && (
                                            <big className='text-danger'>, відхилення: {item.factdiff}</big>
                                        )}
                                        {this.state.state != 13 && this.state.state != 23 && (
                                            <div class="d-flex justify-content-between mt-2">
                                                <button className="btn-agis-light-outline" style={{height: "30px", width: "50px", minWidth: "30px"}} onClick={() => {this.triggerFileInput(this.state.did, "trips", item.item+"")}}><FontAwesomeIcon icon={faCamera}/></button>
                                            </div>
                                        )}
                                    </div>
                                )}
                                {item.fileRequired == 1 && (
                                    <div className='mt-2'>
                                        <big className='text-danger'><b>{item.fileRequiredMessage}</b></big>
                                    </div>
                                )}
                                {item.files.length > 0 && (
                                    <div className="row mt-2">
                                        {item.files.map((file) =>
                                            <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                                                <Preview src={"/serve/driver/expenses/"+this.state.did+"/trips/"+item.item+"/"+file} removeFile={this.state.state != 13 && this.state.state != 23 ? () => {this.removeFile(file, this.state.did, "trips", item.item)} : null} />
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            });
        }
    }

    render() {
        const {lang} = this.context;

        if (this.state.redirect !== null) {
            return <Redirect to={this.state.redirect} />
        }

        const meta = {
			title: localization[lang].title,
			description: localization[lang].title,
			meta: {
			  	charset: 'utf-8'
			}
        };

        if (this.state.isLoading) {
            return (
                <div>Loading...</div>
            );
        }

        return (
            <div>
                <DocumentMeta {...meta} />
                <OffsetTop submenu={false} />

                <input type="file" id="fileInput" className="d-none" onChange={this.changeFileInput} accept=".jpg,.jpeg,.png,.bmp,.tiff,.gif,.mp4,.pdf"/>

                {this.state.isTripCheckpoint && (
                    <div className="fixed-bottom" onClick={() => {this.setState({isTripCheckpoint: false, arrivedRemark: '', arriveItem: null})}} style={{zIndex: "2000", height: "100%", backgroundColor: "#80808094"}}>
                        <div className="fixed-bottom" onClick={(e) => {e.stopPropagation()}} style={{borderTopLeftRadius: "15px", borderTopRightRadius: "15px", backgroundColor: "#fff", overflowX: "auto"}}>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-10 offset-md-1">
                                        <div className="container-fluid pl-0 pr-0">
                                            <div className="row mt-4 mb-2">
                                                <div className="col-12">
                                                    <h5><b>Виконано</b></h5>
                                                </div>
                                            </div>
                                            <div className="row mt-2 mb-2">
                                                <div className="col-12">
                                                    <input type="text" className="input-agis-block" style={{height: '40px', width: '100%'}} placeholder="Примітка..." value={this.state.arrivedRemark} onChange={this.changeArrivedRemark} autoFocus={true} />
                                                </div>
                                            </div>

                                            <div className="row mt-2 mb-3">
                                                <div className="col">
                                                    <Link onClick={this.arrive} className="a-agis-light-outline" style={{height: "40px", width: '100%', minWidth: "0px", backgroundColor: "#1a73e8", color: "white", border: "1px solid #ebebeb"}}>Виконано</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-10 offset-md-1">
                            <div className="container-fluid pl-0 pr-0">

                                <div className="row mb-4">
                                    <div className="col">
                                        <div className="card-agis pt-2 pb-2" style={{borderRadius: "15px", backgroundColor: "rgb(209, 231, 221)", borderColor: "rgb(163, 207, 187)", color: "rgb(10, 54, 34)" }}>
                                            <div class="mb-1">
                                                <big className="">Поточний залишок коштів</big>
                                            </div>
                                            <div>
                                                <big><b>{this.state.balance}</b></big>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="row mb-2">
                                    <div className="col">
                                        <div className="card-agis pt-2 pb-2" style={{borderRadius: "15px"}}>
                                            <div class="d-flex justify-content-between">
                                                <big>
                                                    <b>{this.state.number}</b> від {this.state.date}, <span className={this.state.state == 8 ? "text-warning" : this.state.state == 13 ? "text-danger" : this.state.state == 33 ? "text-success": ""}>{this.state.status}</span>
                                                    {this.state.rid != 0 && (<span className={this.state.rid == 1 ? "badge-danger ml-2" : this.state.rid == 2 ? "badge-warning ml-2" : this.state.rid == 3 ? "badge-success ml-2" : ""} style={{padding: "3px 5px", borderRadius: "4px"}}><b>{this.state.rname}</b></span>)}
                                                </big>
                                            </div>
                                            <div className="mt-1 mb-1">
                                                <big>{this.state.driver1Name}, <a href={"tel:"+this.state.driver1Phone}>{this.state.driver1Phone}</a>, <i>{this.state.driver1Details}</i></big>
                                            </div>
                                            <div>
                                                <big>{this.state.vehicle}</big>
                                            </div>
                                            <div>
                                                <big><b>{this.state.name}</b></big>
                                            </div>
                                            <div>
                                                <big className="text-info">{this.state.time}</big>
                                            </div>
                                            <div>
                                                <big>{this.state.remark}</big>
                                            </div>
                                            <div className="text-right">
                                                <big className="text-success"><b>{this.state.expenses}</b></big>
                                            </div>

                                            {this.state.state == 8 && (
                                                <div class="d-flex justify-content-between mt-2">
                                                    {/* <button className="btn-agis-light-outline" style={{height: "30px", width: "50px", minWidth: "30px"}} onClick={() => {this.triggerFileInput(this.state.did, "", "")}}><FontAwesomeIcon icon={faCamera}/></button> */}
                                                    <button className="btn-agis-success-outline" style={{height: "30px", width: '100%', minWidth: "0px", backgroundColor: !this.state.stateChangeConfirm && "#a3cfbb"}} onClick={(e) => {this.expenseStateChange("33")}}>Старт{this.state.stateChangeConfirm ? '' : ', я впевнений?'}</button>
                                                </div>
                                            )}

                                            {this.state.state == 33 && (
                                                <div class="d-flex justify-content-between mt-2">
                                                    {/* <button className="btn-agis-light-outline" style={{height: "30px", width: "50px", minWidth: "30px"}} onClick={() => {this.triggerFileInput(this.state.did, "", "")}}><FontAwesomeIcon icon={faCamera}/></button> */}
                                                    <button className="btn-agis-danger-outline" style={{height: "30px", width: '100%', minWidth: "0px", backgroundColor: !this.state.stateChangeConfirm && "#f1aeb5"}} onClick={(e) => {this.expenseStateChange("13")}}>Фініш{this.state.stateChangeConfirm ? '' : ', я впевнений?'}</button>
                                                </div>
                                            )}

                                            {this.state.files.length > 0 && (
                                                <div className="row mt-2">
                                                    {this.state.files.map((file) =>
                                                        <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                                                            <Preview src={"/serve/driver/expenses/"+this.state.did+"/"+file} removeFile={this.state.state != 13 && this.state.state != 23 ? () => {this.removeFile(file, this.state.did, "", "")} : null} />
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-between mt-3 mb-2">
                                    <button className={this.state.tab == 'expenses' ? "btn-agis-primary-outline" : "btn-agis-light-outline"} style={{height: "30px", width: '49%', minWidth: "0px", border: "1px solid #ebebeb"}} onClick={() => this.setState({tab: 'expenses'})}>Затрати</button>
                                    <button className={this.state.tab == 'trip' ? "btn-agis-primary-outline" : "btn-agis-light-outline"} style={{height: "30px", width: '49%', minWidth: "0px"}} onClick={() => this.setState({tab: 'trip'})}>Маршрут</button>
                                </div>

                                {this.state.tab == 'expenses' ? (
                                    this.renderExpensesList()
                                ) : (
                                    this.renderTripList()
                                )}

                                <div className="fixed-bottom d-flex align-items-center justify-content-between" style={{zIndex: "4", paddingLeft: "10px", paddingRight: "10px", paddingBottom: "10px", height: "60px"}}>
                                    <button className="btn-agis-light-outline" onClick={() => this.setState({redirect: '/driver/expenses'})} style={{height: "40px", width: '50%', minWidth: "0px", border: "1px solid #ebebeb", backgroundColor: '#fff', boxShadow: '0 1px 6px 0 rgba(32,33,36,0.28)'}}>Назад до рейсів</button>
                                    {this.state.state == 33 && (
                                        <Link to={"/driver/expenses/new/"+ this.state.did} className="a-agis-light-outline" style={{height: '50px', width: "50px", minWidth: "0px", borderRadius: "25px", lineHeight: "44px", backgroundColor: "#1a73e8", color: "white", border: "1px solid #ebebeb", boxShadow: "0 1px 1px rgba(0,0,0,.15)"}}><FontAwesomeIcon icon={faPlus} style={{fontSize: "20px"}} /></Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default InspectionWorkshopList;